import { connectRoutes } from 'redux-first-router';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import querySerializer from 'query-string';
import * as reducers from './reducers';
import * as actions from './actions';

const history = createHistory();

const routesMap = {
  EVENTS: '/',
  RESULTS: '/results',
  BOOKING: '/booking',
  PROFILE: '/profile',
  CAMERA: '/camera',
}

const options = {
  querySerializer,
  onBeforeChange: (dispatch, getState, action) => {},
  onAfterChange: (dispatch, getState) => {},
};

const {
  reducer: routeReducer,
  middleware: routeMiddleware,
  enhancer: routeEnhancer,
} = connectRoutes(history, routesMap, options);

const rootReducer = combineReducers({
  ...reducers,
  location: routeReducer,
});

const middlewares = applyMiddleware(routeMiddleware, thunk);

const enhancers = compose(
  routeEnhancer,
  middlewares,
  window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : f => f
);

const store = createStore(rootReducer, enhancers);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js